const gallerySliderThumbs = new Swiper(".gallery__thumbs", {
  freeMode: true,
  watchSlidesProgress: true,
  spaceBetween: 20,
  breakpoints: {
    0: {
      direction: "horizontal",
      slidesPerView: 2,
    },
    400: {
      slidesPerView: 3,
      direction: "horizontal",
    },

    600: {
      slidesPerView: 4,
      direction: "horizontal",
    },

    800: {
      slidesPerView: 5,
      direction: "horizontal",
    },

    1000: {
      slidesPerView: 6,
      direction: "horizontal",
    },

    1025: {
      slidesPerView: 3,
      direction: "vertical",
    },
  },
});

const gallerySlider = new Swiper(".gallery__slider", {
  autoplay: true,
  thumbs: {
    swiper: gallerySliderThumbs,
  },
});

const gallerySlides = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
];

gallerySlides.forEach((el) => {
  $(".gallery__slider .swiper-wrapper").append(`
    <a href="../../../img/gallery/p${el}.jpg" class="swiper-slide" data-fancybox="photo_gallery">
      <img src="../../../img/gallery/p${el}.jpg" alt="" />
    </a>
  `);

  $(".gallery__thumbs .swiper-wrapper").append(`
    <div class="swiper-slide">
      <img src="../../../img/gallery/p${el}.jpg" alt="" />
    </div>
  `);
});

$(".gallery__arrows-item.prev").on("click", () => {
  gallerySlider.slidePrev();
});

$(".gallery__arrows-item.next").on("click", () => {
  gallerySlider.slideNext();
});

$(".gallery__top-thumbs .arrow.prev").on("click", () => {
  gallerySlider.slidePrev();
});

$(".gallery__top-thumbs .arrow.next").on("click", () => {
  gallerySlider.slideNext();
});
